import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  Paragraph,
  Block,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';


import {
  Breadcrumbs,
  WysiwygField,
  LatestEntitiesSmall,
  FadeWrapper,
} from '../../../../components';

import './style.scss';
import Map from '../../../../components/Map';
import MarkerCluster from '../../../../components/Map/MarkerCluster';
import { locationsUrl, APP_OPTIONS } from '../../../../config/constants';


const NodeLocationDetail = ({ entity, className }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  const nid = entity.getIn(['nid', 0, 'value']);
  const title = entity.getIn(['title', 0, 'value']);
  const emailAddresses = entity.getIn(['field_email', 0, 'value']);
  const address = entity.getIn(['field_address', 0]);
  const telephoneNumbers = entity.getIn(['field_telephone'], List());
  const hideCTABlock = entity.getIn(['field_block_hidden', 0, 'value'], false);

  const remarks = entity.getIn(['field_remarks', 0, 'value']);
  const openingHours = entity.getIn(['field_opening_hours', 0, 'value']);
  const visitingHours = entity.getIn(['field_visiting_hours', 0, 'value']);

  const lat = entity.getIn(['field_geo_location', 0, 'lat'], null);
  const lon = entity.getIn(['field_geo_location', 0, 'lon'], null);
  const center = [lat, lon];

  return (
    <article className="NodeLocationDetail">
      <Container>
        <Breadcrumbs
          data={[
            { url: locationsUrl(currentLanguage), title: t('entities.locations') },
            { title: title },
          ]}
        />
      </Container>
      <Container>
        <div className="row">
          <div className="col-12 col-lg-8 NodeLocationDetail__wrapper">
            <h1>{title}</h1>


            <div className="NodeLocationDetail__inner">
              <div className="NodeLocationDetail__details">
                {address && (
                  <div>
                    <div>{address.get('address_line1')}</div>
                    {address.get('postal_code')}, {address.get('locality')}
                  </div>
                )}
                {telephoneNumbers && (
                  <div className="phone">
                    {telephoneNumbers.map((telephoneNumber) => {
                      return (
                        <a href={`tel:${telephoneNumber.get('value')}`} className="mr-1">
                          {telephoneNumber.get('value')}
                        </a>
                      );
                    })}
                  </div>
                )}
                {emailAddresses && (
                  <div>
                    {emailAddresses && emailAddresses.split(',').map((email) => {
                      return (
                        <>
                          <a href={`mailto:${email}`}>
                            {email}
                          </a>
                          <br />
                        </>
                      );
                    })}
                  </div>
                )}
              </div>

              <br />

              {openingHours && (
                <div className="NodeLocationDetail__content mt-1">
                  <b>{t('general.opening_hours')}:</b>
                  <WysiwygField
                    property="schema:text"
                    className="ParagraphText__body"
                    html={openingHours}
                  />
                </div>
              )}

              {visitingHours && (
                <div className="NodeLocationDetail__content">
                  <b>{t('general.visiting_hours')}:</b>
                  <WysiwygField
                    property="schema:text"
                    className="ParagraphText__body"
                    html={visitingHours}
                  />
                </div>
              )}

              {remarks && (
                <div className="NodeLocationDetail__content">
                  <b>{t('general.remarks')}:</b>
                  <WysiwygField
                    property="schema:text"
                    className="ParagraphText__body"
                    html={remarks}
                  />
                </div>
              )}

            </div>
          </div>
          <div className="col-12 col-lg-4">
            {(lat && lon) && (
              <Map zoom={15} center={center} entity={[entity]} isMapView={false}>
                <MarkerCluster renderOnce markers={[entity]} callback={() => { }} mapLocation={[lat, lon]} />
              </Map>
            )}
          </div>
        </div>
        {LatestEntitiesSmall({
          blockTitle: t('general.local_vacancies'),
          block: 'block_4',
          locationIds: List([nid]),
        })}
      </Container>


      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

      {!hideCTABlock && (
        <Container className="CTABlock">
          <div className="row">
            <div className="CTA__inner scol-12 col-lg-10 offset-lg-1">
              <Block id={APP_OPTIONS.parameters.blockIdLocationCTABlock} />
            </div>
          </div>
        </Container>
      )}
    </article>
  );
};

export default NodeLocationDetail;
